const axios = require("axios");
import cookie from "./cookie";
import { ElNotification } from "element-plus";
let root = null;
let loadObj = {};
export function setRoot(obj) {
  root = obj;
}

export let request = function ({ method = "get", url, data }) {
  root.openLoadng();
  const random = Date.now();
  loadObj[random] = true;
  // console.log(root.appLoading, "rrrrrr");
  let sendObj = {
    method,
    url,
  };
  if (method == "get") {
    sendObj.params = data;
  } else {
    sendObj.data = data;
  }
  if (cookie.get("token")) {
    sendObj.headers = { authorization: cookie.get("token") };
  }

  setTimeout(() => {
    if (loadObj[random]) {
      root.closeLoading();
      delete loadObj[random];
    }
  }, 3 * 60 * 1000);

  return new Promise((resolve, reject) => {
    axios(sendObj)
      .then((res) => {
        root.closeLoading();
        delete loadObj[random];
        if (res.data.code == 0) {
          resolve(res);
        } else {
          ElNotification({
            title: "错误",
            message: res.data.message,
            type: "error",
          });
          reject(res);
        }
      })
      .catch((err) => {
        root.closeLoading();
        delete loadObj[random];
        reject({ data: { code: -1, data: {}, message: "" }, myErr: err });
      });
  });
};

let MyPlugin = {};
MyPlugin.install = function (app, options) {
  // 4. 添加实例方法
  app.config.globalProperties.$myRequest = request;
};
export default MyPlugin;
